<template>
    <div>
        <div>
            <div class="search-bar">
                <input class="btn-block" type="text" v-model="searchData.fullText" name="fullText" placeholder="Suchen..." @keyup.enter="searchMedia()">
                <button class="btn btn-color" @click="searchMedia()"><i class="fa-solid fa-magnifying-glass"></i></button>
            </div>
            <div class="filter-bar">
                <!--<button class="btn filter btn-color" @click="toggleFilter()"><i class="fa-solid fa-filter"></i> Filter</button>-->
                <button class="btn reset btn-color" @click="resetSearch()"><i class="fa-solid fa-trash-can"></i> Zurücksetzen</button>
            </div>
            <!--<div v-if="filter" class="search-filter">
            
            </div>-->
        </div>
    </div>

</template>

<script>
export default {
    name: 'SearchForm',
    data() {
        return {
            searchData: {
                fullText: this.$route.params.query ? this.$route.params.query : "",
                Schlagwort: this.$route.params.keyword ? this.$route.params.keyword : "",
                Autor: this.$route.params.author ? this.$route.params.author : "",
            },
            filter: false,
        }
    },
    mounted() {
        // check at mounted if link has query
        if (this.$route.params.query || this.$route.params.author) {
            //console.log("calling searchForm:mounted()", this.$route.params)
            this.searchMedia();  
        } 
    },
    methods: {
        searchMedia() {
            if (this.searchData.fullText != ""
                || this.searchData.Schlagwort != ""
                || this.searchData.Autor != "") {
                
                if (this.searchData.fullText != "") {
                    this.$router.push({ name: 'search', params: {query: this.searchData.fullText } })
                    this.searchData.Schlagwort = ""
                    this.searchData.Autor = ""
                } else if (this.searchData.Schlagwort != "") {
                    this.$router.push({ name: 'keywordSearch', params: {keyword: this.searchData.Schlagwort } })
                    this.searchData.fullText = ""
                    this.searchData.Autor = ""
                } else if (this.searchData.Autor != "") {
                    this.$router.push({ name: 'author', params: {author: this.searchData.Autor} })
                    this.searchData.fullText = ""
                    this.searchData.Schlagwort = ""
                }
                //console.log("search by params in SearchForm.vue:searchMedia()")
                //console.log("SEARCH DATA", this.searchData)
                this.$store.dispatch('searchByParams', this.searchData);
                this.filter = false;
            }
        },
        resetSearch() {
            this.searchData = {};
            this.filter = false;
            this.$store.state.results = [];
        },
        toggleFilter() {
            // Reset fullText search to enable filter search
            this.searchData.fullText = "";
            this.$router.push({ name: 'start'});
            this.filter = !this.filter; 
        },
    },
    computed: {
        showResults: function() {
            return this.$store.getters.showResults;
        },
    }
}
</script>

<style lang="scss" scoped>
input {
    border-style: none; 
    background: transparent; 
    outline: none; 
    height: 50px;
    padding: 0 55px 0 10px;
    color: #222;
    font-size: 15px;
    line-height: 1.2;
    border: $border;
    text-align: left;
    background-color: $bgColor;
}

.search-bar {
    .btn {
        float: right;
        height: 50px;
        width: 50px;
        text-align: center;
        position: relative;
        top: -50px;
    }
}

.filter-bar {
    .btn {
        margin-right: 15px;
        margin-top: 15px;
    }
}

.search-filter {
    margin-top: 15px;
    input {
        margin-top: 15px;
    }
}

</style>